/* MELT theme — interactions */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const M = window.Melt || {};

  /* ---------- Money ---------- */
  function formatMoney(cents, format = M.moneyFormat || '${{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const n = (value, decimals, thousands = ',', dec = '.') => {
      if (isNaN(value) || value == null) return '0';
      const parts = (value / 100).toFixed(decimals).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? dec + parts[1] : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return n(cents, 2);
        case 'amount_no_decimals': return n(cents, 0);
        case 'amount_with_comma_separator': return n(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return n(cents, 0, '.', ',');
        case 'amount_with_space_separator': return n(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return n(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return n(cents, 2, "'", '.');
        default: return n(cents, 2);
      }
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 2600);
  }

  /* ---------- Overlay / drawers ---------- */
  const overlay = document.createElement('div');
  overlay.className = 'overlay';
  document.body.appendChild(overlay);
  let openDrawer = null;
  let lastFocus = null;

  function open(el) {
    if (!el) return;
    if (openDrawer && openDrawer !== el) close(openDrawer);
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    openDrawer = el;
    const f = el.querySelector('button, a, input');
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 50);
  }
  function close(el = openDrawer) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    openDrawer = null;
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  overlay.addEventListener('click', () => close());
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-open-menu]');
    if (t) { e.preventDefault(); open($('[data-menu-drawer]')); return; }
    const c = e.target.closest('[data-open-cart]');
    if (c && M.cartType !== 'page') { e.preventDefault(); open($('[data-cart-drawer]')); return; }
    if (e.target.closest('[data-close-drawer]')) { e.preventDefault(); close(); return; }
    const m = e.target.closest('[data-open-modal]');
    if (m) { const d = document.getElementById(m.dataset.openModal); if (d && d.showModal) d.showModal(); return; }
    const mc = e.target.closest('[data-close-modal]');
    if (mc) { mc.closest('dialog').close(); }
  });
  document.addEventListener('click', (e) => {
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* ---------- Cart ---------- */
  const cartSection = 'cart-drawer';

  async function refreshCart(openAfter = false) {
    const res = await fetch(`${M.routes.root.replace(/\/$/, '')}/?sections=${cartSection}`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data[cartSection], 'text/html');
    const fresh = html.querySelector('[data-cart-drawer]');
    const drawer = $('[data-cart-drawer]');
    if (fresh && drawer) {
      drawer.querySelector('[data-cart-inner]').replaceWith(fresh.querySelector('[data-cart-inner]'));
      const count = fresh.dataset.count;
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = count === '0' ? '' : count;
        el.dataset.count = count;
        el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      });
    }
    if (openAfter) open(drawer);
  }

  async function changeLine(line, quantity) {
    const drawer = $('[data-cart-drawer]');
    drawer && drawer.classList.add('is-busy');
    try {
      const res = await fetch(M.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (!res.ok) { const err = await res.json(); toast(err.description || err.message || 'Could not update bag'); }
      await refreshCart();
    } finally {
      drawer && drawer.classList.remove('is-busy');
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn || !btn.closest('[data-cart-drawer]')) return;
    e.preventDefault();
    const line = Number(btn.dataset.line);
    const qty = Number(btn.dataset.lineChange);
    changeLine(line, Math.max(0, qty));
  });

  // Product form submit (AJAX)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || M.cartType === 'page') return;
    e.preventDefault();
    const btn = form.querySelector('[data-add-button]');
    const errorEl = form.querySelector('[data-form-error]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    if (errorEl) errorEl.hidden = true;
    try {
      const fd = new FormData(form);
      const res = await fetch(M.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const json = await res.json();
      if (!res.ok || json.status) {
        if (errorEl) { errorEl.textContent = json.description || json.message || 'Something went wrong'; errorEl.hidden = false; }
        return;
      }
      await refreshCart(true);
    } catch (err) {
      form.submit();
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    }
  });

  /* ---------- Product: variants, gallery, bundles ---------- */
  function initProduct(root) {
    const jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const variants = data.variants;
    const picker = root.querySelector('[data-variant-picker]');
    const idInput = root.querySelector('[data-variant-id]');
    const addBtn = root.querySelector('[data-add-button]');
    const addText = root.querySelector('[data-add-text]');
    const addLabel = addText ? addText.textContent : 'Add to bag';
    const qtyInput = root.querySelector('[data-qty-input]');
    const track = root.querySelector('[data-gallery-track]');
    const slides = track ? $$('.gallery__slide', track) : [];
    const thumbs = $$('[data-thumb]', root);
    const dots = $$('.gallery__dot', root);
    let current = variants.find((v) => String(v.id) === String(idInput && idInput.value)) || variants[0];

    const getSelected = () => {
      if (!picker) return current.options;
      return $$('fieldset', picker).map((fs) => {
        const c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    };

    function goTo(i, smooth = true) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
    }
    function markActive(i) {
      thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === i));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
    }
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.thumb))));
    if (track) {
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => markActive(Math.round(track.scrollLeft / track.clientWidth)));
      }, { passive: true });
    }

    function updateAvailability(selected) {
      if (!picker) return;
      $$('fieldset', picker).forEach((fs, idx) => {
        $$('input', fs).forEach((input) => {
          const test = selected.slice();
          test[idx] = input.value;
          const match = variants.find((v) => v.options.every((o, i) => o === test[i]));
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function updateBundles(variant) {
      $$('.bundle', root).forEach((b) => {
        const qty = Number(b.dataset.qty);
        const disc = Number(b.dataset.discount);
        const full = variant.price * qty;
        const deal = Math.round(full * (100 - disc) / 100);
        const p = b.querySelector('[data-bundle-price]');
        const c = b.querySelector('[data-bundle-compare]');
        if (p) p.textContent = formatMoney(deal);
        if (c) c.textContent = formatMoney(full);
      });
    }

    function render(variant) {
      current = variant;
      if (idInput) idInput.value = variant ? variant.id : '';
      const priceEl = root.querySelector('[data-price]');
      if (priceEl && variant) {
        priceEl.querySelector('[data-price-current]').textContent = formatMoney(variant.price);
        const cmp = priceEl.querySelector('[data-price-compare]');
        const badge = priceEl.querySelector('[data-price-badge]');
        const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceEl.classList.toggle('price--sale', !!sale);
        if (cmp) { cmp.hidden = !sale; if (sale) cmp.textContent = formatMoney(variant.compare_at_price); }
        if (badge) { badge.hidden = !sale; if (sale) badge.textContent = `Save ${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}%`; }
      }
      const sticky = root.querySelector('[data-sticky-price]');
      if (sticky && variant) sticky.textContent = formatMoney(variant.price);
      const available = variant && variant.available;
      [addBtn, root.querySelector('[data-sticky-button]')].forEach((b) => { if (b) b.disabled = !available; });
      if (addText) addText.textContent = !variant ? 'Unavailable' : available ? addLabel : 'Sold out';
      if (variant) {
        updateBundles(variant);
        if (variant.featured_media) {
          const idx = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
          if (idx > -1) goTo(idx);
        }
        if (root.closest('.template-product') || document.body.classList.contains('template-product')) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    if (picker) {
      picker.addEventListener('change', (e) => {
        const fs = e.target.closest('fieldset');
        const label = fs && fs.querySelector('[data-option-label]');
        if (label) label.textContent = e.target.value;
        const selected = getSelected();
        let match = variants.find((v) => v.options.every((o, i) => o === selected[i]));
        if (!match) {
          // fall back to first available variant with the changed option
          const idx = Number(fs.dataset.optionIndex);
          match = variants.find((v) => v.options[idx] === e.target.value && v.available) || variants.find((v) => v.options[idx] === e.target.value);
          if (match) {
            $$('fieldset', picker).forEach((f, i) => {
              const input = $$('input', f).find((inp) => inp.value === match.options[i]);
              if (input) { input.checked = true; const l = f.querySelector('[data-option-label]'); if (l) l.textContent = input.value; }
            });
          }
        }
        updateAvailability(getSelected());
        render(match || null);
      });
      updateAvailability(getSelected());
    }

    // Bundles / quantity
    const bundles = $$('.bundle', root);
    bundles.forEach((b) => {
      b.addEventListener('change', () => {
        bundles.forEach((x) => x.classList.toggle('is-active', x === b));
        if (qtyInput) qtyInput.value = b.dataset.qty;
        else ensureQtyHidden(b.dataset.qty);
      });
    });
    function ensureQtyHidden(q) {
      const form = root.querySelector('[data-product-form]');
      if (!form) return;
      let h = form.querySelector('input[name="quantity"]');
      if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'quantity'; form.appendChild(h); }
      h.value = q;
    }
    const activeBundle = bundles.find((b) => b.classList.contains('is-active'));
    if (activeBundle) { if (qtyInput) qtyInput.value = activeBundle.dataset.qty; else ensureQtyHidden(activeBundle.dataset.qty); }

    $$('[data-qty-minus], [data-qty-plus]', root).forEach((b) => {
      b.addEventListener('click', () => {
        if (!qtyInput) return;
        const v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + (b.hasAttribute('data-qty-plus') ? 1 : -1));
        qtyInput.value = v;
        bundles.forEach((x) => {
          const on = Number(x.dataset.qty) === v;
          x.classList.toggle('is-active', on);
          const r = x.querySelector('input'); if (r) r.checked = on;
        });
      });
    });

    // Sticky add to cart
    const stickyBar = root.querySelector('[data-sticky-atc]');
    const anchor = root.querySelector('[data-buy-anchor]');
    if (stickyBar && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', String(!show));
        const sb = stickyBar.querySelector('button'); if (sb) sb.tabIndex = show ? 0 : -1;
      }).observe(anchor);
    }
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(scope = document) {
    const els = $$('.reveal:not(.is-in)', scope);
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- 3D tilt ---------- */
  function initTilt(scope = document) {
    if (!finePointer || reduceMotion || M.tilt === false) return;
    $$('[data-tilt]', scope).forEach((el) => {
      if (el.dataset.tiltBound) return;
      el.dataset.tiltBound = '1';
      const max = Number(el.dataset.tiltMax || 8);
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width;
        const py = (e.clientY - r.top) / r.height;
        el.classList.add('is-tilting');
        el.style.setProperty('--ry', `${(px - .5) * max * 2}deg`);
        el.style.setProperty('--rx', `${(.5 - py) * max * 2}deg`);
        el.style.setProperty('--mx', `${px * 100}%`);
        el.style.setProperty('--my', `${py * 100}%`);
      });
      el.addEventListener('pointerleave', () => {
        el.classList.remove('is-tilting');
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- Hero parallax ---------- */
  function initParallax() {
    if (!finePointer || reduceMotion) return;
    const layers = $$('[data-depth]');
    if (!layers.length) return;
    let tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
    window.addEventListener('pointermove', (e) => {
      tx = e.clientX / window.innerWidth - .5;
      ty = e.clientY / window.innerHeight - .5;
      if (!raf) raf = requestAnimationFrame(loop);
    });
    function loop() {
      cx += (tx - cx) * .08; cy += (ty - cy) * .08;
      layers.forEach((l) => {
        const d = Number(l.dataset.depth);
        l.style.translate = `${cx * d * 40}px ${cy * d * 40}px`;
      });
      raf = Math.abs(tx - cx) + Math.abs(ty - cy) > .001 ? requestAnimationFrame(loop) : null;
    }
  }

  /* ---------- Cursor glow ---------- */
  function initCursor() {
    const g = $('.cursor-glow');
    if (!g || !finePointer || reduceMotion) return;
    let x = 0, y = 0, gx = 0, gy = 0, raf = null;
    window.addEventListener('pointermove', (e) => {
      x = e.clientX; y = e.clientY; g.classList.add('is-on');
      if (!raf) raf = requestAnimationFrame(loop);
    });
    document.addEventListener('pointerleave', () => g.classList.remove('is-on'));
    function loop() {
      gx += (x - gx) * .12; gy += (y - gy) * .12;
      g.style.transform = `translate3d(${gx - 190}px, ${gy - 190}px, 0)`;
      raf = Math.abs(x - gx) + Math.abs(y - gy) > .5 ? requestAnimationFrame(loop) : null;
    }
  }

  /* ---------- Header hide on scroll ---------- */
  function initHeader() {
    const h = $('[data-header]');
    if (!h || h.dataset.sticky === 'false') return;
    let last = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      h.classList.toggle('is-hidden', y > last && y > 300 && !openDrawer);
      last = y;
    }, { passive: true });
  }

  /* ---------- Reviews carousel ---------- */
  function initCarousels(scope = document) {
    $$('[data-carousel]', scope).forEach((wrap) => {
      const track = wrap.querySelector('[data-carousel-track]');
      $$('[data-carousel-prev], [data-carousel-next]', wrap).forEach((b) => b.addEventListener('click', () => {
        const step = (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width : 300) + 20;
        track.scrollBy({ left: b.hasAttribute('data-carousel-next') ? step : -step, behavior: 'smooth' });
      }));
    });
  }

  /* ---------- Marquee duplication ---------- */
  function initMarquees(scope = document) {
    $$('.marquee', scope).forEach((m) => {
      if (m.dataset.dup) return;
      m.dataset.dup = '1';
      const track = m.querySelector('.marquee__track');
      if (!track) return;
      for (let i = 0; i < 2; i++) {
        const c = track.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        m.appendChild(c);
      }
    });
  }

  function initAll(scope = document) {
    $$('[data-product-root]', scope).forEach(initProduct);
    initReveal(scope);
    initTilt(scope);
    initCarousels(scope);
    initMarquees(scope);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll();
    initParallax();
    initCursor();
    initHeader();
    requestAnimationFrame(() => document.body.classList.add('is-loaded'));
  });
  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));

  window.Melt = Object.assign(M, { formatMoney, refreshCart, openDrawer: open, closeDrawer: close });
})();
